import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Route,
    Router,
    RouterStateSnapshot,
    UrlSegment,
    UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import {
    AuthenticatorService,
    Permission,
    UserPage,
} from '../Services/authenticator.service';
import { PingService } from '../Services/ping.service';
import { MatSnackBar } from '@angular/material/snack-bar';
@Injectable({
    providedIn: 'root',
})
export class AuthorizedGuard {
    constructor(
        private auth: AuthenticatorService,
        private router: Router,
        private pingService: PingService,
        private snackBar: MatSnackBar
    ) {}

    async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
        const backend = await this.pingService.makePing();

        if (backend) {
            // const token: string | undefined =
            //     await this.pingService.recaptchaV3('guardAction');
            // const recaptcha = token
            //     ? await this.pingService.validateRecapchaV3(token)
            //     : true;

            const recaptcha = true;

            if (recaptcha) {
                const logged: Permission = await this.auth.isLogged();

                if (logged.access) {
                    if (logged.enCierre) {
                        if (route.data.cierreRole == route.data.expectedRole) {
                            return true;
                        } else {
                            this.router.navigate([UserPage.ServiciosEscolares]);
                            return false;
                        }
                    } else {
                        const hasAccess = this.auth.user.roles.includes(
                            route.data.expectedRole
                        );

                        if (!hasAccess)
                            this.router.navigate([this.auth.userPage]);
                        return hasAccess;
                    }
                } else {
                    this.router.navigate(['/login']);
                    return false;
                }
            } else {
                this.snackBar.open(
                    'Tráfico inusual procedente de tu red de computadoras',
                    '🤖',
                    {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'right',
                        panelClass: ['snack-error-message'],
                    }
                );
                return false;
            }
        } else {
            this.snackBar.open(
                'El servidor no puede atender temporalmente su solicitud debido a un tiempo de inactividad por mantenimiento o problemas de capacidad. Por favor, inténtelo de nuevo más tarde.',
                '🤖',
                {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'right',
                    panelClass: ['snack-error-message'],
                }
            );
            return false;
        }
    }

    async canLoad(route: Route): Promise<boolean> {
        const backend = await this.pingService.makePing();
        if (backend) {
            const logged: Permission = await this.auth.isLogged();

            if (logged.access) {
                if (logged.enCierre) {
                    if (route.data.cierreRole == route.data.expectedRole) {
                        return true;
                    } else {
                        this.router.navigate([UserPage.ServiciosEscolares]);
                        return false;
                    }
                } else {
                    const hasAccess = this.auth.user.roles.includes(
                        route.data.expectedRole
                    );

                    if (!hasAccess) this.router.navigate([this.auth.userPage]);
                    return hasAccess;
                }
            } else {
                this.router.navigate(['/login']);
                return false;
            }
        } else {
            return false;
        }
    }
}
